const BASE_URL = window.location.protocol + '//' + window.location.host;
export const API_URL_MAYOR =  BASE_URL + '/o/c/calendars/scopes/';
export const API_URL_SECRETARY =  BASE_URL + '/o/c/calendarsecretarios/scopes/';
export const API_USERNAME = 'visualizar.agenda@gmail.com';
export const API_PASSWORD = 'LIFEray@123';
export const MAX_RESULTS = 20;
